/**
* This file is loaded asyncronously in the footer.
* All custom global scripts should be included here.
*/

	/*
	A little info for this js file:

	As much as possible, this file should be kept organized. Currently, two major divisions are seen below, delinitated by their respective functions of "on load" and "ready".
		As mentioned below, most code added to this file should be included within the "on load" function.

	For ease of future use, include any new code at the bottom of the relevant section of the page, adding clear comments to explain the purpose of the code being written,
		including any relavant details regarding what the code overrides, etc.
	*/


	(function(){
		'use strict';
	
		// rerun lazyload on screen size updates
		window.addEventListener( 'resize', function() {
			dbs.lazyload();
		});
	
		// Load event function ... most custom stuff goes here. Safer for async.
		window.addEventListener( 'load', function() {
			/**
			 * Close Locations Modal
			 */
			var closeLocationsModal = document.getElementById('location-modal-close');
			if ( closeLocationsModal ) {
				closeLocationsModal.addEventListener('click', function() {
					document.getElementById('location-modal').style.display = 'none';
				});
			}
			
			/* Search Form functionality
			 * The click functionality involves three different actions,
			 * depending on conditions the various clicks provide.
			 */
			var searchOpen = document.querySelectorAll( '.search-form__button--open' );
			var searchClose = document.querySelectorAll( '.search-form__button--close' );
	
			if ( searchOpen ) {
				for (var i=0; searchOpen.length > i; i++) {
					searchOpen[i].addEventListener( 'click', function() {
						this.parentElement.classList.add( 'search-form--active' );
						this.parentElement.querySelector('.site_search__field').focus();
			
						// Hide the search bar after click out of it
						document.getElementById( 'content' ).addEventListener( 'click', function() {
							if ( this.parentElement.classList.contains( 'search-form--active' ) ) {
								this.parentElement.classList.remove( 'search-form--active' );
							}
						});
					});
				}
				
				for (var i=0; searchClose.length > i; i++) {
					searchClose[i].addEventListener( 'click', function() {
						this.parentElement.classList.remove( 'search-form--active' );
					});
				}
			}
	
	
			/**
			 * Linkclicker
			 * 
			 * A class placed on a wrapping element with a link inside to make the wrapper clickable.
			 * Note: the container should have only one link.
			 */
			var linkclickers = document.querySelectorAll('.linkclicker');
	
			for ( var i = 0; linkclickers.length > i; i++ ) {
				var linkclicker = linkclickers[i];
	
				linkclicker.addEventListener('click', function(e) {
					e.preventDefault();
					var link = this.querySelector('a');
					var linkPath = link.getAttribute('href');
					
					if ( link.getAttribute('target', "_blank") ) {
						window.open(linkPath);
					} else {
						window.location.href = linkPath;
					}
				});
			}
	
	
			/**
			 * Force external links/PDFs to open in a new tab.
			 * From https://stackoverflow.com/questions/2910946/test-if-links-are-external-with-jquery-javascript
			 * 2019-07-11 - TA
			 */
			function link_is_external(link_element) {
				return ( link_element.host !== window.location.host || link_element.href.indexOf("pdf") > -1 );
			}
	
			var anchorElements = document.getElementsByTagName('a');
			for ( let anchorElement of anchorElements ) {
	
				if ( link_is_external( anchorElement ) ) {
					anchorElement.setAttribute( 'target','_blank' );
					anchorElement.setAttribute( 'rel','noopener' );
	
					// Add assistive text to alert of external links
					var assistiveText = '<span class="assistive">. External Link. Opens in new window.</span>';
					var assistiveTextContainer = document.createElement( 'span' );
					assistiveTextContainer.innerHTML = assistiveText;
					anchorElement.appendChild( assistiveTextContainer.firstChild );
				}
			}
	
			/**
			 * Detects if element is in viewport
			 * 
			 * @usage
			 * var el = document.querySelector('.element-class');
			 *
			 * window.addEventListener('scroll', function(event) {
			 * 		if (isInViewport(el)) {
			 *			el.classList.add("in-view");
			 *		}
			 * }, false);
			 * 
			 * NOTE: If the whole layout is taller than the viewport, this will never fire. It is often
			 * better to target one small element inside a layout.
			 */
			function isInViewport(elem) {
				var distance = elem.getBoundingClientRect();
				return (
					distance.top >= 0 &&
					distance.left >= 0 &&
					distance.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
					distance.right <= (window.innerWidth || document.documentElement.clientWidth)
				);
			};
	
			/**
			 * ANOTHER NOTE: Right now the idea is to use this as needed on certain layouts, rather 
			 * than querying all elements of a certain class globally and looping through them. 
			 * However, that is a reasonable approach if there is a significant amount of 
			 * scroll animations being done; especially if it's already on the home page. Here
			 * is an example of how that would be done.
			 */
			// var els = document.querySelectorAll('.animated');
			
			// for (let i = 0; els.length > i; i++) {
			// 	let _this = els[i];
			// 	window.addEventListener('scroll', function(event) {
			// 		if ( isInViewport(_this) ) {
			// 			_this.classList.add("in-view");
			// 		}
			// 	}, false);
			// }
	
	
			/**
			 * Populate "Speak to an Expert" form field with product of current page
			 * 
			 * The client does not want top-level product pages to have this functionality, so we will
			 * use those top-level category-like pages to key off of and determine if the form field 
			 * should get populated.
			 */
			if (window.jQuery) {
				var productField = document.querySelector('.product-field');
	
				if (productField) {
					var productFieldInput = productField.querySelector('input');
					
					if (productFieldInput.value) {
						productField.classList.add('active');
					}
					
					var parents = [
						'accessories',
						'body-protection',
						'eye-protection',
						'face-protection',
						'fire-helmets',
						'hard-hats',
						'respiratory',
						'thermal-imaging',
						'body-temperature-management'
					];
	
					var path = location.pathname.split('/')[1];
					var inParents = parents.indexOf(path) > -1;
					
					if ( inParents ) {
						console.log('is child' );
						var title = document.querySelector('h1').innerText;
						productFieldInput.value = title;
						productField.classList.add('active');
					}
				}
			}

			var sessionRegion = sessionStorage.getItem('bullard_active_region');

			// Ensure cookie is not null first
			var checkCookie = setInterval(function () {

				if ( readCookie('bullard_active_region') ) {
					clearInterval(checkCookie);

					if (dbs.http_host.indexOf('eu.') > -1 || dbs.http_host.indexOf('de.') > -1 || dbs.http_host.indexOf('apac.') > -1) {
						if (document.getElementById('location-modal')) {
							document.getElementById('location-modal').style.display = 'none';
						}
					// Set to read sessionStorage
					} else if (readCookie('bullard_active_region') && readCookie('bullard_active_region') !== 'americas' && sessionRegion == null) {
						document.getElementById('location-modal').style.display = 'flex';
					}
				}
			}, 100);
		}); // End of load function
		
	
		// Include ready events here
		window.addEventListener( 'DOMContentLoaded', function() {
			
		});
	
		// region switcher menu changes. 2022-05-03
		document.addEventListener( 'input', function (event) {
			if ( event.target.id !== 'region-switcher' ) return;
			var region = readCookie( 'bullard_active_region' );
			var new_region = event.target.value;  // the dropdown value
			var cookiedays = 7;
			if ( dbs.debug ) console.log('new region: ' + new_region + '   region: ' + region);
			var host = dbs.domain;
			if ( dbs.debug ) console.log( 'host:' + host);
	//		if (new_region == region ) return;  // do nothing
			// erase cookie first since its possible to have different cookies per domain. 2022-05-03
			// setCookie( 'bullard_active_region', null, -99 );  // not working :(, prolly don't need it.
			setCookie( 'bullard_active_region', new_region, "" );
			if ( dbs.debug ) console.log('set new region: ' + new_region );
			if ( new_region === 'americas' ) {
				window.location.href = '//' + host;
				if ( dbs.debug ) console.log('host am: ' + host );
			} else {
				window.location.href = '//' + new_region + '.' + host;
				if ( dbs.debug ) console.log('host not americas: ' + new_region + '.' + host );
			}
		});
	
		var regions = {
			'americas': 'americas',
			'europe-eu': 'eu',
			'europe-de': 'de',
			'asia': 'apac'
		};
	
		Object.keys(regions).map(function (region) {
			document.getElementById(`modal-${region}`).addEventListener('click', function() {
				modalRedirectRegion(regions[region]);
			});
		})
	
		function modalRedirectRegion(region) {
			if ( dbs.debug ) console.log( 'host:' + dbs.domain);
			// Set sessionStorage
			sessionStorage.setItem( 'bullard_active_region', region );
			// setCookie( 'bullard_active_region', region,"" );
			if ( dbs.debug ) console.log('set new region: ' + region );
			if ( region === 'americas' ) {
				window.location.href = '//' + dbs.domain;
				if ( dbs.debug ) console.log('host am: ' + dbs.domain );
			} else {
				window.location.href = '//' + region + '.' + dbs.domain;
				if ( dbs.debug ) console.log('host not americas: ' + region + '.' + dbs.domain );
			}
		}
	})();
	